const WINDOW_TOKEN_KEY = '__CREHANA_TALENT_TOKEN__';

let talentToken: string | undefined;

const readTokenFromWindow = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const tokenInWindow = (
    window as typeof window & {
      [WINDOW_TOKEN_KEY]?: string;
      crehApolloHeaders?: Record<string, string>;
    }
  )[WINDOW_TOKEN_KEY];

  if (tokenInWindow) {
    return tokenInWindow;
  }

  return window.crehApolloHeaders?.['talent-token'];
};

export const setTalentToken = (token?: string) => {
  talentToken = token;

  if (typeof window === 'undefined') {
    return;
  }

  const browserWindow = window as typeof window & {
    [WINDOW_TOKEN_KEY]?: string;
  };

  if (!token) {
    delete browserWindow[WINDOW_TOKEN_KEY];
    return;
  }

  browserWindow[WINDOW_TOKEN_KEY] = token;
};

export const getTalentToken = () => {
  if (talentToken) {
    return talentToken;
  }

  const tokenFromWindow = readTokenFromWindow();
  if (tokenFromWindow) {
    talentToken = tokenFromWindow;
  }

  return tokenFromWindow;
};

export const getAuthorizationHeader = () => {
  const token = getTalentToken();
  if (!token) {
    return undefined;
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};
